<template>
  <div>
    <div v-if="$store.state.web3.account && !$store.state.user.local_user.id" class="cp c" @click="actionSignin()">
      {{lg('',{
        en: 'SIGN IN',
        zh: '登录',
      })}}
    </div>

    <div v-if="$store.state.user.local_user.id">
      <router-link :to="{name: 'profile'}">
        <span class="ui-avatar size-30">
          <img :src="$store.state.user.local_user.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import bus from '@/bus.js'

export default {
  name: 'btnUserLogin',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    actionSignin(){
      bus.headervue.mark_sign_ui_call += 1
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>